module.exports = __webpack_public_path__ + "static/media/349.1039aa63.webp";